const mobileMenuLinks = document.querySelectorAll( '.mobile-menu-link' );

mobileMenuLinks.forEach( mobileMenuLink => {
	mobileMenuLink.addEventListener( 'click', () => {
		const closeMenu = document.querySelector( '[data-close-menu]' );
		if ( closeMenu ) closeMenu.click();
	} );
} );
